import { ProductExchangeRecommendationSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/product-exchange-recommendation";
import { ReturnReasonSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/return-reasons";
import { ReturnProductSchema } from "@redotech/redo-model/draft-return/draft-return-items";
import { ReturnTypeEnum } from "@redotech/redo-model/return";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getMerchantRecommendedExchangeProducts = {
  name: "getMerchantRecommendedExchangeProducts" as const,
  input: z.object({
    draftReturnId: z.string(),
    returnProduct: ReturnProductSchema,
    returnReasons: z.array(ReturnReasonSchema),
    returnType: createEnum(ReturnTypeEnum).optional(),
  }),
  output: z.array(ProductExchangeRecommendationSchema),
};
